import { Component, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Icons } from '@vex/icons/icons';
@Component({
  selector: 'vex-session-dialog',
  templateUrl: './session-dialog.component.html',
  styleUrls: ['./session-dialog.component.scss']
})
export class SessionDialogComponent extends Icons implements OnDestroy {
  remaining_time: number = 30;
  timer: any;
  private readonly deadline: number;

  constructor(
    public dialogRef: MatDialogRef<SessionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: { deadline?: number }
  ) {
    super();
    this.deadline = Number(data?.deadline) || Date.now() + 30000;
    this.updateRemainingTime();
    this.timer = setInterval(() => {
      this.updateRemainingTime();
    }, 1000);
  }

  /** Uses an absolute deadline so background-tab throttling cannot reset the warning. */
  private updateRemainingTime(): void {
    this.remaining_time = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
    if (this.remaining_time === 0) {
      this.onDismiss();
    }
  }

  onConfirm(): void {
    clearInterval(this.timer);
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    clearInterval(this.timer);
    this.dialogRef.close(false);
  }

  ngOnDestroy(): void {
    clearInterval(this.timer);
  }
}
